import { useEffect, useRef } from 'react';
import { DropdownOption } from '../../../../common/_custom/Dropdown/dropdownTypes';
import { ACCOUNT_SWITCH_LOADING_MS } from './constants';

export function useAccountSwitchLoading(setLoadingData: (isLoading: boolean) => void, onSelect: (selectedOption: DropdownOption) => void) {
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => () => clearTimeout(timerRef.current), []);

    return (selectedOption: DropdownOption) => {
        setLoadingData(true);
        onSelect(selectedOption);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => setLoadingData(false), ACCOUNT_SWITCH_LOADING_MS);
    };
}
